import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'splitUrlImage' })
export class SplitUrlImage implements PipeTransform {
  transform(url: string) {
    let urlSplitted = url.split('"')[1];
    return urlSplitted;
  }
}